import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
    ButtonBase,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import MBack from '../view/MBack';
import Apis from '../../network/Apis';
import AppUtils from '../../control/apputlis';


class IntegralDetail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            score: 0
        };
    }

    componentDidMount() {
        this.encryptionUserScoreList();
        AppUtils.YMPush('MAIN', 'IntegralDetail');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    encryptionUserScoreList = async () => {
        let { channel, uid, token } = this.props.match.params;
        let result = await Apis.encryptionUserScoreList(uid, token, channel);
        console.log('encryptionUserScoreList', result);
        if (result.code == 200) {
            this.setState({ data: result.data.list, score: result.data.score });
        }
    }

    render() {
        const { classes } = this.props;
        const { data, score } = this.state;

        let { nav } = this.props.match.params;

        return (
            <MBack title='积分明细' backgroundColor="#FFF" hideNav={nav}>
                <Grid container direction='column' alignItems='center' className={classes.myInfo}>
                    <Grid container direction='row' alignItems='baseline' justify='flex-start'  >
                        <Typography style={{ fontSize: 40, color: "#0D0D0D", marginTop: 24, marginLeft: 12, fontWeight: 'bold' }}>{score}</Typography>
                        <Typography style={{ fontSize: 10, color: "#919191", marginTop: 24, marginLeft: 4 }}>积分</Typography>
                    </Grid>
                    <Grid className={classes.root} />
                </Grid>

                <Grid className={classes.container}>
                    {
                        data.map((item, i) => (
                            <Grid key={i} container direction='row' alignItems='center' justify='space-between' style={{ height: 50 }} >
                                <Typography style={{ fontSize: 14, color: "#000000", fontWeight: 'bold' }}>{item.amount > 0 ? ("+" + item.amount + "积分") : (item.amount + "积分")}</Typography>
                                <Typography style={{ fontSize: 12, color: "#919191" }}>{item.time}</Typography>
                            </Grid>
                        ))
                    }
                </Grid>
            </MBack >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    myInfo: {
        paddingTop: 12,
        backgroundColor: '#EEEEEE'
    },
    root: {
        backgroundColor: '#FFF',
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        marginTop: 12,
        height: 12,
        width: '100%'
    },
    container: {
        backgroundColor: '#FFF',
        borderRadius: 10,
        paddingBottom: 12,
        paddingRight: 16,
        paddingLeft: 16
    }

}))(IntegralDetail));